<template>
  <div>
    <b-alert :show="errors.length > 0" variant="danger">
      <p v-for="item of errors" v-bind:key="item">{{ item }}</p>
    </b-alert>
    <EnamadReal
      v-if="
        loadedResultInquiry != null &&
        (loadedResultInquiry.usertype === 1 ||
          loadedResultInquiry.usertype === 2)
      "
      @validattion="validattion"
      :submitted="submitted"
    />
    <EnamadLegal v-else @validattion="validattion" :submitted="submitted" />
  </div>
</template>


<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_INQUIRY_ENAMAD } from "@/core/services/store/inquiryEnamad.module";
import { REGISTER_WITH_ENAMAD } from "@/core/services/store/registerWithEnamad.module";
import { validationMixin } from "vuelidate";
import sessionHelper from "../../helpers/sessionHelper";
import EnamadLegal from "../../components/Enamad/EnamadLegal.vue";
import EnamadReal from "../../components/Enamad/EnamadReal.vue";
export default {
  name: "enamad",
  mixins: [validationMixin],
  components: {
    EnamadReal,
    EnamadLegal,
  },
  data() {
    return {
      submitted: false,
      errors: [],
    };
  },
  watch: {},
  computed: {
    loadedResultInquiry() {
      return this.$store.getters.loadedResultInquiry;
    },
  },
  mounted() {
    let params;
    params=this.$route.params.domain;
    // params="asnaf5.4etest.com"
    this.getInquiryEnamad(params);
  },
  methods: {
    getInquiryEnamad(params) {
      this.$store.dispatch(GET_INQUIRY_ENAMAD, params);
    },
    validattion(user) {
      this.submitted = true;
      this.$store
        .dispatch(REGISTER_WITH_ENAMAD, user)
        .then((data) => {
          if (data.success) {            
            sessionHelper.setUser(data.result);
            this.$router.push({path:"/dashboard",query: { from: "NewUserFromEnamad" }})
          } else {
            this.errors = [];
            for (const key in data.error) {
              if (data.error.hasOwnProperty(key)) {
                const element = data.error[key];
                this.errors.push(element[0]);
              }
            }
            this.toTop();
          }
        })
        .catch((error) => {
          this.$makeToast(
            "danger",
            "خطای سمت سرور",
            `لطفا در زمان دیگری عملیات مورد نظر را انجام دهید.`,
            4000
          );
        })
        .finally(() => {
          this.submitted = false;
        });
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
</style>

